import axios, { AxiosRequestConfig } from 'axios';
//import { Toast } from 'antd-mobile';
import qs from 'qs';
//import history from '@tools/history';
//import store from '@/store';
//import { setUserInfo } from '@store/appSlice';

const IS_DEV = process.env.NODE_ENV === 'development';

// eslint-disable-next-line
interface ResponseData<D = any, TD = any> {
  code: number;
  count: number;
  data: D;
  msg: string;
  twodata: TD;
}

const instance = axios.create({
  timeout: 60000,
  baseURL: IS_DEV ? '/' : process.env.REACT_APP_BASE_URL,
});

instance.interceptors.request.use(
  (config) => {
    // 将参数为 null 的字段重置为 undefined
    if (config.data) {
      Object.keys(config.data).forEach((key) => {
        if (config.data[key] === null) {
          config.data[key] = undefined;
        }
      });

      config.data = qs.stringify(config.data);
    }

    if (config.params) {
      Object.keys(config.params).forEach((key) => {
        if (config.params[key] === null) {
          config.params[key] = undefined;
        }
      });
    }

    if (!config.noAuth) {
      // header 带上 token 做验证
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        config.headers && (config.headers.userInfoToken = JSON.parse(userInfo).jwt);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// instance.interceptors.response.use(
//   (response) => {
//     if (response.data.code === 1) {
//       return Promise.resolve(response.data);
//     }

//     if (response.config.responseMsgVisible != false) {
//       // 统一弹出错误信息
//       Toast.show({
//         content: response.data.msg,
//         icon: 'fail',
//         position: 'top',
//       });
//     }

//     // -10/-20 未登录或者登录失效，清除 userInfo，返回到登录界面
//     if (response.data.code === -10 || response.data.code === -20) {
//       history.push('/login');
//       store.dispatch(setUserInfo({}));
//     }

//     return Promise.reject(response.data);
//   },
//   (error) => {
//     // 统一弹出错误信息
//     Toast.show({-

//       content: error.message,
//       icon: 'fail',
//       position: 'top',
//     });

//     return Promise.reject(error);
//   },
// );

let responseMsgVisible = true;
// eslint-disable-next-line
const post = <RD = any, RTD = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig) => {
  return instance.post<void, ResponseData<RD, RTD>, D>(url, data, config);
};

// eslint-disable-next-line
const get = <RD = any, RTD = any, D = any>(url: string, config?: AxiosRequestConfig) => {
  return instance.get<void, ResponseData<RD, RTD>, D>(url, config);
};

let $http = {
  responseMsgVisible,
  post,
  get,
};

export default $http;
